import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/task_immediate/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/task_immediate/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/task_immediate/remove', qs.stringify(params),options);


export const update = (params, options) =>
request.post('/api/task_immediate/submit', params,options)

// 获取项目列表
export const getProjectList = (params, options) =>
    request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

// 获取系统字典
export const getDictionary = (code, options) =>
    request.get('/api/blade-system/dict/dictionary?code=' + code, Object.assign({}, options, {}));

// 生成 制定临时任务
export const addTemTask = (params, options) =>
        request.post('/api/v4ward/task/taskimmediate/generate', params,options)
